<tui-push class="update-push" *tuiPush="true" [lines]="8" (close)="toggle(false)">
  <nb-card>
    <tui-icon icon="rocket"/>
    <div i18n="@@DostupnaNovayaVersiyaSIspravleniyami">Доступна новая версия с исправлениями. Хотите обновиться?</div>
    <button nbButton type="button" (click)="toggle(true)" status="primary" size="small" i18n="@@Obnovit2">
      Обновить
    </button>
    <button nbButton (click)="toggle(false)" size="small" i18n="@@Pozzhe">
      Позже
    </button>
  </nb-card>
</tui-push>
